import ExternalWalletConnect from './ExternalWalletConnect.js';
import ExternalWalletInstall from './ExternalWalletInstall.js';
import { jsx } from 'react/jsx-runtime';

function ExternalWalletDetail(props) {
  const {
    connectButton,
    walletConnectUri,
    goBack,
    closeModal
  } = props;
  return /*#__PURE__*/jsx("div", {
    children: connectButton.hasWalletConnect ?
    /*#__PURE__*/
    // Wallet Connect
    jsx(ExternalWalletConnect, {
      connectButton: connectButton,
      walletConnectUri: walletConnectUri,
      goBack: goBack,
      closeModal: closeModal
    }) :
    /*#__PURE__*/
    // Download wallets
    jsx(ExternalWalletInstall, {
      connectButton: connectButton,
      goBack: goBack,
      closeModal: closeModal
    })
  });
}

export { ExternalWalletDetail as default };
